import React, { useRef } from 'react';

import useScrollAnimate from 'hooks/useScrollAnimation';

type AnimateType =
  // Attention seekers
  | 'pulse'
  // Bouncing entrances
  | 'bounceIn'
  | 'bounceInDown'
  // Fading entrances
  | 'fadeIn'
  | 'fadeInLeft'
  | 'fadeInRight';

interface AnimateProps extends React.HTMLAttributes<HTMLDivElement> {
  extendClassName?: string;
  type?: AnimateType;
}

const Animate: React.FC<AnimateProps> = ({
  children,
  extendClassName,
  type,
  ...rest
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const animate = useScrollAnimate(ref);
  return (
    <div
      ref={ref}
      className={
        animate
          ? `${extendClassName} animate animate-${type || ''}`
          : `${extendClassName} preanimate`
      }
      {...rest}
    >
      {children}
    </div>
  );
};

Animate.defaultProps = {
  extendClassName: undefined,
  type: undefined,
};

export default Animate;
